import { Link } from "react-router-dom";
import cx from "classnames";

// Components
import Search from "../../Search/SearchContainer";

// CSS
import styles from "../header.module.scss";

// Constants
const logoSrc =
    require("../../../assets/logos/symphony-innovate-logo.svg").default;

export const HeaderRowTwo = (props) => {
    const { clearTags, history, location, setIsSideMenuActive } = props;

    const isVideoRoute = location.pathname.includes("videos");

    return (
        <div className={cx(styles.row, styles["row--two"])}>
            <div
                className={styles.more}
                onClick={() => setIsSideMenuActive((prev) => !prev)}
            >
                <span
                    className={cx(
                        styles.icon,
                        "material-icons material-icons-outlined"
                    )}
                >
                    menu
                </span>
                <span className={styles.text}>MORE</span>
            </div>
            <div className={styles.options}>
                <Search classes={styles.search} history={history} />
                <Link
                    className={cx(styles.link, {
                        [styles["link--active"]]: isVideoRoute,
                    })}
                    onClick={clearTags}
                    to="/videos"
                >
                    VIDEOS
                </Link>
            </div>
            <div className={styles.logo}>
                <Link to="/">
                    <img alt="Symphony Innovate logo" src={logoSrc} />
                </Link>
            </div>
        </div>
    );
};
